<template>
  <div>
    <show-goods-table :goods-list="goodsList" :isForm="true" :class="$style['promotion-form-table']" :firstColumnPrice="firstColumnPrice">
      <template>
        <el-table-column label="商品规格">
          <template slot-scope="scope">
            {{scope.row.specifications.name}}
          </template>
        </el-table-column>
        <el-table-column label="价格（元）" min-width="120">
          <template slot-scope="scope">
            <div v-for="(item,i) in goodsPriceShow(scope.row)" :key="i">
              <span v-if="item.text" :class="$style['price-text']">{{item.text}}</span>
              <span>{{item.price}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="参加满减" v-if="openFullReduction">
          <template slot-scope="scope">
            <el-switch :value="scope.row.useFullReduction" @change="openuseFullReduction(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="活动价（元）" v-if="is_TIME_LIMIT_DISCOUNT||is_CASHBACK" minWidth="100">
          <template slot-scope="scope">
            <wt-input v-if="is_SNAP_UP" :class="$style['number-input-price']" v-model="scope.row.snapUp_price" placeholder="秒杀价格" data-vv-as="秒杀商品价格"
                      name="name" v-validate="'required'">
              <el-button slot="append">¥</el-button>
            </wt-input>
            <wt-input :class="$style['number-input-price']" :disabled="isActive" v-model="scope.row.discount_show" @blur="changeTimePrice(scope.row)"
                      placeholder="商品价格" data-vv-as="商品活动价" name="name" type="number" v-validate="'required|decimal:2|min_value:0|is_not:0'">
              <el-button slot="append">¥</el-button>
            </wt-input>
          </template>
        </el-table-column>
        <el-table-column :label="is_SNAP_UP?'秒杀设置':'折扣'" minWidth="90">
          <template slot-scope="scope">
            <div :class="$style['seckilling-setting']" v-if="is_SNAP_UP">
              <wt-input :class="$style['number-input-price']" v-model="scope.row.snapUp_price" @blur="snapUpPriceBlur(scope.row)" placeholder="秒杀价格"
                        data-vv-as="秒杀商品价格" name="name" v-validate="'required|decimal:2|min_value:0|is_not:0'">
                <el-button slot="append">¥</el-button>
              </wt-input>
              <wt-input :class="$style['number-input-price']" v-model="scope.row.amount" placeholder="库存" data-vv-as="秒杀商品库存" type="number" name="name"
                        v-validate="'required'">
                <el-button slot="append">份</el-button>
              </wt-input>
            </div>
            <template v-else>
              <wt-input :disabled="isActive" :class="$style['number-input-discount']" v-model="scope.row.discount_discount_show" @blur="blurPrice(scope.row)"
                        placeholder="折扣" data-vv-as="优惠活动商品折扣" type="number" name="name" v-validate="'required|decimal:1|discount'">
                <el-button slot="append">折</el-button>
              </wt-input>
            </template>
          </template>
        </el-table-column>
        <template v-if="is_CASHBACK">
          <el-table-column label="购买者返现金额" minWidth="100">
            <template slot-scope="scope">
              <wt-input :disabled="isActive" v-model="scope.row.buyer_cashBack" placeholder="购买者返现金额" :class="$style['number-input-price']" data-vv-as="购买者返现金额"
                        name="name" type="number" v-validate="'required|decimal:2|min_value:0|is_not:0'" @blur="changeCashBack(scope.row,'buyer_cashBack')">
                <el-button slot="append">¥</el-button>
              </wt-input>
            </template>
          </el-table-column>
          <el-table-column label="分享人返现金额" minWidth="100">
            <template slot-scope="scope">
              <wt-input :disabled="isActive" v-model="scope.row.sharer_cashBack" placeholder="分享人返现金额" :class="$style['number-input-price']"
                        data-vv-as="分享人返现金额" name="name" type="number" v-validate="'required|decimal:2|min_value:0|is_not:0'"
                        @blur="changeCashBack(scope.row,'sharer_cashBack')">
                <el-button slot="append">¥</el-button>
              </wt-input>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteGoods(scope.row,scope.$index)" :disabled="isActive">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </show-goods-table>
  </div>
</template>
<script>
import showGoodsTable from '../show-goods-table'
import { cashCount } from '@/utils/formUtils'
export default {
  props: {
    // goodsList: {
    //   type: Array,
    //   default: function () {
    //     return []
    //   }
    // },
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    promotionType: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    openFullReduction: Boolean
  },
  data () {
    return {
      goodsList: JSON.parse(JSON.stringify(this.value))
    }
  },
  computed: {
    is_TIME_LIMIT_DISCOUNT () {
      return this.promotionType === 'TIME_LIMIT_DISCOUNT'
    },
    is_SNAP_UP () {
      return this.promotionType === 'SNAP_UP'
    },
    firstColumnPrice () {
      return this.promotionType !== 'CASH_BACK'
    },
    // 是否是优惠/返券通用促销活动
    is_CASHBACK () {
      return this.promotionType === 'CASH_BACK'
    }
  },
  components: {
    showGoodsTable
  },
  watch: {
    goodsList: {
      handler: function (val) {
        this.$emit('selelctGoods', val)
      },
      deep: true
    },
    value: {
      handler: function (val) {
        this.goodsList = val
      }
    }
  },
  methods: {
    openuseFullReduction (row) {
      this.$set(row, 'useFullReduction', !row.useFullReduction)
    },
    deleteGoods (val, index) {
      this.$emit('deleteGoods', val, index)
    },
    // 商品价格显示（区分订金/尾款）
    goodsPriceShow (val) {
      let priceArr = []
      let depositObj = {
        text: '订金',
        price: val.deposit_no_sign
      }
      let balanceObj = {
        text: '尾款',
        price: val.balance_no_sign
      }
      let allPriceObj = {
        text: (this.hasDepositAndBalance(val) && (val.deposit_no_sign || val.balance_no_sign)) ? '全款' : null,
        price: val.final_price_no_sign
      }
      if (this.hasDepositAndBalance(val)) {
        if (val.deposit_no_sign) {
          priceArr.push(depositObj)
        }
        if (val.balance_no_sign) {
          priceArr.push(balanceObj)
        }
      }
      if (this.hasLumpSum(val)) {
        if (val.final_price_no_sign) {
          priceArr.push(allPriceObj)
        }
      }
      console.log('priceArr', priceArr)
      return priceArr
    },
    // 选择商品是否有’订金+尾款‘付款方式
    hasDepositAndBalance (val) {
      return val.paymentModes && val.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1
    },
    // 选择商品是否有‘全款’付款方式
    hasLumpSum (val) {
      return val.paymentModes && val.paymentModes.indexOf('LUMP_SUM') > -1
    },
    getGoodsPrice (val) {
      let price
      let deposit
      if (val.specifications && val.specifications.specificationId) {
        price = val.specifications.price || null
        deposit = this.hasDepositAndBalance(val) ? val.specifications.deposit : null
      } else {
        price = (val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.finalPrice) || null
        deposit = this.hasDepositAndBalance(val) ? (val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.noSpecificationsDeposit) : null
      }
      return { deposit: deposit, price: price }
    },
    // 输入活动加不合格错误提示
    discountShowMessage (val, text) {
      this.$set(val, 'discount_show', '')
      this.$set(val, 'discount_discount_show', '')
      if (val.specifications.discount) {
        this.$set(val.specifications, 'discount', '')
      }
      this.$message.error(text)
    },
    changeTimePrice (val) {
      let deposit = this.getGoodsPrice(val).deposit// 订金
      let priceT = this.getGoodsPrice(val).price// 全款
      if (val.discount_show) {
        let errText
        if (cashCount(val.discount_show) >= priceT) {
          errText = '请输入小于商品价格的优惠价格'
          this.discountShowMessage(val, errText)
        } else if (this.hasDepositAndBalance(val) && cashCount(val.discount_show) <= deposit) {
          errText = '请输入大于商品订金的优惠价格'
          this.discountShowMessage(val, errText)
        } else {
          let price = parseFloat(val.final_price.replace('¥', ''))
          this.$set(val, 'discount_discount_show', ((val.discount_show * 10 / price).toFixed(1)))
        }
      } else {
      }
    },
    changeCashBack (val, fileName) {
      if (val[fileName]) {
        if (val.discount_show) {
          if (Number(val[fileName]) >= Number(val.discount_show)) {
            this.$message.error('请输入小于商品活动价的返现金额')
            this.$set(val, fileName, null)
          }
        } else {
          this.$message.error('请先输入"活动价"')
          this.$set(val, fileName, null)
        }
      }
    },
    snapUpPriceBlur (val) {
      let price = this.getGoodsPrice(val)
      if (val.snapUp_price && cashCount(val.snapUp_price) > price) {
        this.$set(val, 'snapUp_price', '')
        this.$message.error('请输入小于商品价格的秒杀价格')
      }
    },
    blurPrice (val) {
      if (val.discount_discount_show > 10) {
        this.$set(val, 'discount_show', '')
        this.$set(val, 'discount_discount_show', '')
        this.$message.error('请输入小于10的优惠折扣')
      } else {
        let price = parseFloat(val.final_price.replace('¥', ''))
        if (val.discount_discount_show) {
          this.$set(val, 'discount_show', (price * (val.discount_discount_show / 10)).toFixed(2))
        }
        this.changeTimePrice(val)
      }
    }
  }
}
</script>
<style module lang="less">
.number-input-price{
    max-width: 200px;
    min-width: 120PX;
    margin-right: 10px;
    :global
    .el-button{
        padding: 10px
    }
}
.number-input-discount{
     max-width: 150px;
    min-width: 80PX;
    margin-right: 10px;
     :global
    .el-button{
        padding: 10px
    }
    :global
    input[type="number"]{
      padding: 0 5px!important
    }
}
.promotion-form-table{
margin-top: 20px;
padding:0;
background:#fff
}
.price-text{
  margin-right: 10px
}
</style>
